import {
    APP_INITIALIZER,
  NgModule,
  provideZoneChangeDetection,
} from '@angular/core';
import { RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { routes } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { VersionManagementComponent } from './pages/version-management/version-management.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HTTP_INTERCEPTORS,
  withFetch,
} from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import {
  AuthModule,
  AuthService,
  AuthHttpInterceptor,
} from '@auth0/auth0-angular';
import { filter, firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule, MatSelectionList } from '@angular/material/list';
import { FilterService, GridAllModule, GridModule, GroupService, PagerModule, PageService, SortService } from '@syncfusion/ej2-angular-grids';
import { InPlaceEditorAllModule } from '@syncfusion/ej2-angular-inplace-editor';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { AccordionModule, AppBarModule, BreadcrumbModule, CarouselModule, ContextMenuModule, MenuModule, SidebarModule, StepperModule, TabModule, ToolbarModule, TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { ClientComponent } from './pages/client/client.component';
import { FailedComponent } from './pages/failed/failed.component';
import { CallbackComponent } from './pages/callback/callback.component';
import { MatDialogModule, MatDialogTitle } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { DialogTemplateComponent } from './utility/dialog-template/dialog-template.component';
import { ErrorDetailDialogComponent } from './utility/error-detail-dialog/error-detail-dialog.component';
import { EventPayloadDialogComponent } from './utility/event-payload-dialog/event-payload-dialog.component';
import { TaskEventHistoryComponent } from './pages/task-event-history/task-event-history.component';
import { DialogService } from './utility/dialog/dialog-service';
import { EditDialogService } from './utility/dialog/edit-dialog-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterService } from './utility/router-service';
import { HttpService } from './utility/http-service';
import { ScheduleService } from '../../src/app/pages/schedules/schedule.service';
import { ComboBoxModule, DropDownListAllModule, DropDownListModule, MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { ClientIconEditorComponent } from './pages/client-icon-editor/client-icon-editor.component';
import { MatTreeModule, MatTree } from '@angular/material/tree';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs'
import { MapsModule } from '@syncfusion/ej2-angular-maps'
import { LoginService } from '../services/login-service';
import { GlobalUsersComponent } from './pages/global-users/global-users.component';
import { DashboardAccessComponent } from './pages/dashboard-access/dashboard-access.component';
import { GroupRecordAccessSyncComponent } from './pages/group-record-access-sync/group-record-access-sync.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';
import { RolesPanelComponent } from './components/roles-panel/roles-panel.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GenericDragSelectComponent } from './components/generic-drag-select/generic-drag-select.component';
import { SchedulesMapComponent } from './pages/schedules/schedules-map/schedules-map.component';
import { SchedulesHeaderComponent } from './pages/schedules/schedules-header/schedules-header.component';
import { FracCalendarComponent } from './pages/schedules/frac-calendar/frac-calendar.component';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatOption } from '@angular/material/select';
import { MatSlider } from '@angular/material/slider';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { DateAdapter, MatNativeDateModule, NativeDateAdapter } from '@angular/material/core';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { DateFormatterPipe } from './pipes/date-formatter.pipe';
import { StatusColorPipe } from './pipes/status-color.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserRegistrationComponent } from './pages/user-registration/user-registration.component';
import { PendingUsersComponent } from './pages/pending-users/pending-users.component';
import { JobGridComponent } from './pages/schedules/schedules-header/job-grid.component';
import { UserSettingsComponent } from './pages/user-settings/user-settings.component';
import { UploadConfirmationComponent } from './pages/schedules/upload-confirmation/upload-confirmation.component';
import { ArchiveSchedulesComponent } from './pages/schedules/archive-schedules/archive-schedules.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RejectedUsersComponent } from './pages/rejected-users/rejected-users.component';
import { CacheManagementComponent } from './pages/cache-management/cache-management.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import { LoadingService } from '../services/loading.service';
import { WcHomeComponent } from './pages/wc-home/wc-home.component';
import { WaterSharingWelcomeComponent } from './pages/water-sharing/ws-welcome/ws-welcome.component';
import { WaterSharingHomeComponent } from './pages/water-sharing/ws-home/ws-home.component';
import { WsMenuComponent } from './pages/water-sharing/ws-menu/ws-menu.component';
import { WsDashboardComponent } from './pages/water-sharing/ws-dashboard/ws-dashboard.component';
import { WsTradeStatsComponent } from './pages/water-sharing/ws-statistics/ws-trade-stats.component';
import { WaterRequestFormComponent } from './pages/water-sharing/ws-request-form/ws-request-form.component';
import { DevSupportComponent } from './pages/dev-support/dev-support.component';
import { UserManualsComponent } from './pages/user-manuals/user-manuals.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { WcGridModule } from './components/wc-grid/wc-grid.module';
import { DashboardsComponent } from './pages/dashboards/dashboards.component';
import { PolicyExplorerComponent } from './pages/policy-explorer/policy-explorer.component';
import { PolicyExplorerMainComponent } from './pages/policy-explorer/policy-explorer-main/policy-explorer-main.component';
import { RecentlyViewedComponent } from './components/recently-viewed/recently-viewed.component';
import { AttachmentComponent } from './pages/attachments/attachment.component';
import { AttachmentHierarchyEditorComponent } from './pages/attachment-hierarchy-editor/attachment-hierarchy-editor.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MapViewComponent } from './pages/schedules/map-view/map-view.component';
import { ProdDataComponent } from './pages/prod-data/prod-data.component';
import { ProdDataDetailComponent } from './pages/prod-data/prod-data-detail/prod-data-detail.component';
import { IdleWarningDialogComponent } from './utility/idle-warning-dialog/idle-warning-dialog.component';

/**
 * Auth0 SPA configuration -- Authorization Code Flow with PKCE.
 *
 * There is no client secret: the SDK generates a code_verifier per login,
 * sends only its SHA-256 challenge to /authorize, and presents the verifier at
 * /oauth/token. That is what makes a public browser client safe to do a code
 * flow with, and it replaces the implicit-style flow MSAL was configured for.
 */
export const auth0Config = {
  domain: environment.auth0.domain,
  clientId: environment.auth0.clientId,
  authorizationParams: {
    redirect_uri: environment.auth0.authorizationParams.redirect_uri,
    // Requesting an audience is what makes Auth0 return a signed JWT access
    // token rather than an opaque one. Without it the .NET hosts cannot
    // validate anything.
    audience: environment.auth0.authorizationParams.audience,
  },

  // Refresh tokens rather than hidden-iframe silent auth: Safari and Firefox
  // block the third-party cookies that iframe renewal depends on, so without
  // this a session would die at access-token expiry. Requires "Allow Offline
  // Access" on the API and Refresh Token Rotation on the application.
  useRefreshTokens: true,
  // Do not fall back to iframe renewal when a refresh token is unavailable --
  // failing loudly is better than a renewal path that only works in Chrome.
  useRefreshTokensFallback: false,

  // Matches the previous MSAL setup (BrowserCacheLocation.LocalStorage), so the
  // session survives a reload and is shared across tabs -- both of which the
  // idle-timeout handling in AppComponent assumes.
  cacheLocation: 'localstorage' as const,

  httpInterceptor: {
    // Replaces MSAL's protectedResourceMap: attaches the access token to calls
    // at the API origin and nothing else. The trailing `*` matters -- without
    // it only the bare origin matches and every real request goes out bare.
    allowedList: [
      {
        uri: `${environment.apiConfig.uri}*`,
        tokenOptions: {
          authorizationParams: {
            audience: environment.auth0.authorizationParams.audience,
          },
        },
      },
    ],
  },
};

export function initApp(auth: AuthService, authInit: LoginService) {
  return async () => {
    // Let the SDK finish processing a redirect callback (?code=&state=) before
    // anything renders. Without this the guards can observe a transiently
    // anonymous user on the way back from Auth0 and bounce to login again.
    await firstValueFrom(auth.isLoading$.pipe(filter(loading => !loading)));

    const isAuthenticated = await firstValueFrom(auth.isAuthenticated$);
    if (isAuthenticated) {
      try {
        await authInit.ensureUserLoaded();
      } catch {
        // APP_INITIALIZER factories must all resolve before Angular bootstraps
        // anything -- a rejection here (e.g. the 401 WellChron.Server returns
        // for an account with no WellChron access role) would otherwise stop
        // the app from mounting at all, on any full page load, leaving a
        // permanently blank page with nothing to even show an error from.
        // UserHydrationGuard handles the actual redirect once routing runs.
      }
    }
  };
}

@NgModule({
  declarations: [
    AppComponent,
    ClientComponent,
    FailedComponent,
    CallbackComponent,
    DialogTemplateComponent,
    ErrorDetailDialogComponent,
    EventPayloadDialogComponent,
    TaskEventHistoryComponent,
    VersionManagementComponent,
    ClientIconEditorComponent,
    MapViewComponent,
    GlobalUsersComponent,
    DashboardAccessComponent,
    GroupRecordAccessSyncComponent,
    UserManagementComponent,
    GenericDragSelectComponent,
    SchedulesMapComponent,
    SchedulesHeaderComponent,
    FracCalendarComponent,
    UserRegistrationComponent,
    PendingUsersComponent,
    RejectedUsersComponent,
    JobGridComponent,
    UserSettingsComponent,
    UploadConfirmationComponent,
    ArchiveSchedulesComponent,
    CacheManagementComponent,
    LoadingOverlayComponent,
    WcHomeComponent,
    WaterSharingWelcomeComponent,
    WaterSharingHomeComponent,
    WsMenuComponent,
    WsDashboardComponent,
    WsTradeStatsComponent,
    WaterRequestFormComponent,
    UserManualsComponent,
    DashboardsComponent,
    PolicyExplorerComponent,
    PolicyExplorerMainComponent,
    RecentlyViewedComponent,
    AttachmentComponent,
    AttachmentHierarchyEditorComponent,
    ProdDataComponent,
    ProdDataDetailComponent,
    IdleWarningDialogComponent,
  ],

  imports: [
    RolesPanelComponent,
    ReactiveFormsModule,
    MatDialogModule,
    FormsModule,
    BrowserModule,
    AccordionModule,
    ToolbarModule,
    ContextMenuModule,
    BreadcrumbModule,
    CarouselModule,
    TabModule,
    TreeViewModule,
    SidebarModule,
    MenuModule,
    AppBarModule,
    StepperModule,
    GridModule,
    PagerModule,
    CommonModule,
    AuthModule.forRoot(auth0Config),
    RouterOutlet,
    RouterLink,
    RouterModule.forRoot(routes),
    MatInputModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    MatListModule,
    GridAllModule,
    QueryBuilderModule,
    ComboBoxModule,
    DropDownListModule,
    MatIconModule,
    MultiSelectModule,
    DropDownListModule,
    DropDownListAllModule,
    MatTreeModule,
    MatProgressBarModule,
    MatTree,
    MatSelectModule,
    MatOption,
    MatSlider,
    MatSliderModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatDatepickerModule,
    MatNativeDateModule,
    InPlaceEditorAllModule,
    TextBoxModule,
    MapsModule,
    DragDropModule,
    DatePickerModule,
    WcGridModule,
    DateFormatterPipe,
    StatusColorPipe,
    SafeUrlPipe,
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatRadioModule,
    MatCheckboxModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatDividerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatExpansionModule,
    MatSnackBarModule
  ],

  exports: [
    JobGridComponent
  ],

  providers: [
    DialogService,
    EditDialogService,
    RouterService,
    HttpService,
    MatDatepickerModule,
    LoginService,
    ScheduleService,
    DateFormatterPipe,
    StatusColorPipe,
    LoadingService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    PageService,
    SortService,
    FilterService,
    GroupService,
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AuthService, LoginService],
      multi: true,
    },
    provideNoopAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    // Attaches the Auth0 access token to requests matching auth0Config's
    // httpInterceptor.allowedList. Directly replaces MsalInterceptor.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
